import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TemplatesService {

  private _inventoryapiUrl = `${environment.inventory}`;

  constructor(
    private _http: HttpClient
  ) { }

  // Get inventory template by ID
  getInventoryTemplate(templateId:any):Observable<any>{
    return this._http.get(`${this._inventoryapiUrl}/template/${templateId}`);
  }

  // Update inventory template
  updateInventoryTemplate(templateId:any, formData:any):Observable<any>{
    return this._http.put(`${this._inventoryapiUrl}/updatetemplate/${templateId}`, formData);
  }

  // Get all templates in inventory
  getAllTemplates(fromQuote:any, pageNumber:any, pageSize:any, token:any):Observable<any>{
    return this._http.post<any>(`${this._inventoryapiUrl}/templates?quote=${fromQuote}`, {});
  }

  // update template which are visible to user during quote creeation
  updateVisibleTemplates(templateIds:any):Observable<any>{
    return this._http.put(`${this._inventoryapiUrl}/visibilityoftemplates`, templateIds);
  }

  getAllTemplatesFromBase():Observable<any>{
    return this._http.get(`${this._inventoryapiUrl}/alltemplates`);
  }

  updateBaseTemplates(templates:any):Observable<any>{
    return this._http.post(`${this._inventoryapiUrl}/changedefaulttemplates`, templates);
  }

}
